import request from "../utils/request.js"
// 登录
export function loginApi(params) {
    return request({
        url: "/noToken/login",
        method: "post",
        data: params,
    })
}
// 验证登录状态
export function verifyApi() {
    return request({
        url: "/anno/newVerify",
        method: "get",
    })
}